import { action } from '@reatom/framework'

import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

export const fetchFeeConfigRequestAction = action(async (ctx) => {
  const { tradeApiClient } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.services.servicesFeeConfigList, []),
  )

  return result
}, 'fetchFeeConfigRequestAction')
